import React from 'react';
import PropTypes from 'prop-types';

import Money from '../../../components/Money';

const PredefinedAmounts = ({ gcAmount, onGcAmountChange, predefinedAmounts }) => (
  <div>
    {
      predefinedAmounts.map((amount, idx) => (
        <div className={`layout__item u-pl- u-1/${predefinedAmounts.length}`} key={amount}>
          <div className="c-select-btn">
            <input
              className="c-select-btn__input"
              type="radio"
              id={`gc-amount-preset-${idx}`}
              name="radio-reserve"
              onChange={() => onGcAmountChange(amount)}
              checked={amount === gcAmount}
            />
            <label className="c-select-btn__label c-select-btn__label_tiny" htmlFor={`gc-amount-preset-${idx}`}>
              <div className="c-heading c-heading--huge">
                <Money>{amount}</Money>
              </div>
            </label>
          </div>
        </div>
      ))
    }
  </div>
);

PredefinedAmounts.propTypes = {
  gcAmount: PropTypes.number.isRequired,
  onGcAmountChange: PropTypes.func.isRequired,
  predefinedAmounts: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default PredefinedAmounts;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCardAmount/PredefinedAmounts.jsx